import React from 'react';
import {
  AlertCircle,
  AlertTriangle,
  CheckCircle,
  Clipboard,
  Clock,
  CreditCard,
  FileText,
  Grid,
  Inbox,
  Package,
  RotateCcw,
  Send,
  Shield,
  ShoppingBag,
  ShoppingCart,
  Truck,
  XCircle,
} from 'react-feather';

export const ORDER_STATUS_ICON_SIZE = 16;

const iconProps = {
  size: ORDER_STATUS_ICON_SIZE,
  strokeWidth: 1.8,
};

function CartClockIcon(props) {
  const { size = ORDER_STATUS_ICON_SIZE, strokeWidth = 1.8 } = props;
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">
      <path d="M3 4h2l2.2 10.4a2 2 0 0 0 2 1.6h6.6a2 2 0 0 0 1.9-1.4L20 8H7" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" />
      <path d="M9 20h.01M16 20h.01" stroke="currentColor" strokeWidth={strokeWidth + 1} strokeLinecap="round" />
      <path d="M16 3v3l2 1" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" />
      <path d="M16 9a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z" stroke="currentColor" strokeWidth={strokeWidth} />
    </svg>
  );
}

function CartCheckIcon(props) {
  const { size = ORDER_STATUS_ICON_SIZE, strokeWidth = 1.8 } = props;
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">
      <path d="M3 4h2l2.2 10.4a2 2 0 0 0 2 1.6h6.6a2 2 0 0 0 1.9-1.4L20 8H7" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" />
      <path d="M9 20h.01M16 20h.01" stroke="currentColor" strokeWidth={strokeWidth + 1} strokeLinecap="round" />
      <path d="M14 4.8 16 6.8 20 2.8" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

function BoxCheckIcon(props) {
  const { size = ORDER_STATUS_ICON_SIZE, strokeWidth = 1.8 } = props;
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">
      <path d="M21 8 12 3 3 8l9 5 9-5Z" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" />
      <path d="M3 8v8l9 5 9-5V8" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" />
      <path d="M9.5 16.5 11 18l3.5-4" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export const ORDER_STATUS_ICONS = {
  all: <Grid {...iconProps} />,
  new: <FileText {...iconProps} />,
  requestConfirmation: <Clipboard {...iconProps} />,
  confirmed: <Shield {...iconProps} />,
  orderRequest: <ShoppingBag {...iconProps} />,
  ordering: <CartClockIcon {...iconProps} />,
  ordered: <CartCheckIcon {...iconProps} />,
  arrivedInStock: <Inbox {...iconProps} />,
  preparing: <Clock {...iconProps} />,
  composed: <FileText {...iconProps} />,
  packing: <Package {...iconProps} />,
  packed: <BoxCheckIcon {...iconProps} />,
  shippedOut: <Send {...iconProps} />,
  delivered: <Truck {...iconProps} />,
  waitingForCheck: <AlertCircle {...iconProps} />,
  success: <CheckCircle {...iconProps} />,
  outOfStock: <AlertCircle {...iconProps} />,
  needsAction: <AlertTriangle {...iconProps} />,
  cancel: <XCircle {...iconProps} />,
  return: <RotateCcw {...iconProps} />,
  payment: <CreditCard {...iconProps} />,
};

export const getOrderStatusIcon = (key) => ORDER_STATUS_ICONS[key] || ORDER_STATUS_ICONS.orderRequest;
